// @spec VUL-STR-043
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { SlaComplianceReportPage } from '@/features/vulnerabilities/pages/SlaComplianceReportPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/vulnerabilities/sla-report')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.slaComplianceReport'),
  }),
  component: SlaComplianceReportPage,
});
